import fetch from 'node-fetch'

export async function getShopPayPlans() {
  const domain = process.env.SHOP_DOMAIN
  const apiVersion = process.env.SHOP_API_VERSION || '2025-01'
  const storefrontToken = process.env.SHP_TOKEN

  const response = await fetch(`https://${domain}/api/${apiVersion}/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': storefrontToken,
    },
    body: JSON.stringify({
      query: `
        query GetShopPayPlans {
          shop {
            shopPayInstallmentsPricing {
              financingPlans {
                id
                maxPrice { amount currencyCode }
                minPrice { amount currencyCode }
                terms {
                  apr
                  frequency
                  installmentsCount { count precision }
                  loanType
                }
              }
              minPrice { amount currencyCode }
              maxPrice { amount currencyCode }
            }
          }
        }
      `,
    }),
  })

  if (!response.ok) {
    throw new Error(`Shopify API error: ${response.statusText}`)
  }

  const data = await response.json()
  return data
}
